import React from "react";
import { Switch, Checkbox, Row, Col, Collapse, Radio, Form } from "antd";
//style
import styles from "./form.module.css";
const { Panel } = Collapse;

const DashboardFrom = ({ disabledState }) => {
  return (
    <Collapse defaultActiveKey={["dashboard_1"]} expandIconPosition="end">
      <Panel header="Dashboard" key="dashboard_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>PMS Dashboard</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="dashboard_pms_tile_show"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={disabledState}>Show</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Marriott FOSSE</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="dashboard_marriott_fosse_show"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={disabledState}>Show</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default DashboardFrom;
